import { trackPromise } from 'react-promise-tracker';
import { fetchUserTimezone, login } from '../redux/user';
import { setCustomer, getCustomerData } from '../redux/customer';
import AuthService from '../services/authorization';
import { getCustomer } from '../services/customerService';
import { useSessionLoading } from '../contexts/SessionLoadingContext';
import { useAppDispatch } from '../redux/store';

export const useSession = () => {
  const dispatch = useAppDispatch();
  const Auth = new AuthService();
  const { startSessionLoading, stopSessionLoading } = useSessionLoading();

  const createSession = async () => {
    startSessionLoading();

    try {
      let currentUser = Auth.getCurrentUser();

      if (
        !currentUser ||
        currentUser.customer_number !== Auth.getCurrentCustomerNumber() ||
        parseInt(currentUser.login_user_id) !== parseInt(Auth.getUserId() || '')
      ) {
        currentUser = await trackPromise(Auth.createSession());
      }

      dispatch(login(currentUser));
      dispatch(fetchUserTimezone(currentUser));

      const customer = await trackPromise(
        getCustomer(currentUser.customer_number)
      )

      if (customer) {
        dispatch(setCustomer(customer))
        dispatch(getCustomerData(customer))
      }

      return { currentUser, customer };
    } catch (error) {
      console.error('Error creating session:', error);
      throw error;
    } finally {
      stopSessionLoading();
    }
  };

  const initializeSession = async () => {
    const isLoggedIn = await Auth.loggedIn();
    if (isLoggedIn) {
      createSession();
    }
  };

  return {
    createSession,
    initializeSession,
    Auth
  };
};
